/* eslint-disable */
export default {
  _cloud: 'cloud',
}